import React from "react";
import { MetadataElement, MetadataElementList } from "./SingleUploadModel";
import DatePicker from "componentsV2/DatePicker/DatePicker";
import dayjs from "dayjs";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { singleUploadActions } from "actions/singleUpload";

interface DateFieldProps {
  element: MetadataElement;
}

const DateFieldWrapper: React.FC<DateFieldProps> = ({ element }) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const singleUploadPayload = useSelector((state: any) => state.singleUpload.payload);

  const handleDateChange = (date: any) => {
    const updatedPayload = singleUploadPayload?.metadata_collection?.metadata_element_list?.find(
      (el: MetadataElement) => el.name === element.name
    );
    if (updatedPayload) {
      // Update the specific field's value
      updatedPayload.metadata_element_list.forEach((el: MetadataElement) => {
        if (el.field_id === element.field_id) {
          const formattedDate = date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""; // Format the date in local timezone
          el.value = {id: formattedDate, display_value: formattedDate}; // Update the value with id and display_value
        }
      });
      // Dispatch the updated payload to the Redux stor
      const updatedSingleUploadPayload = {
        ...singleUploadPayload,
        metadata_collection: {
          ...singleUploadPayload.metadata_collection,
          metadata_element_list: singleUploadPayload.metadata_collection.metadata_element_list.map((el: MetadataElementList) =>
            el.name === updatedPayload.name ? updatedPayload : el
          ),
        },
      };
      dispatch(singleUploadActions.updateSingleUploadPayload(updatedSingleUploadPayload)); // Dispatch the updated payload

    } else {
      console.warn(`Element with name "${element.name}" not found in metadata_element_list.`);
    }
  };
  const selectedValue = singleUploadPayload?.metadata_collection?.metadata_element_list?.find(
    (el: MetadataElement) => el.name === element.name
  )?.metadata_element_list?.find((el: MetadataElement) => el.field_id === element.field_id)?.value?.display_value || "";
  // Convert the selected value back to a Date object for the DatePicker
  const dateVal = selectedValue ? dayjs(selectedValue) : null;

  return (
    <DatePicker
      onChangeHandler={handleDateChange} // Replace with actual handler
      valueField={dateVal} // Replace with actual value field
    />
  );
};

export default DateFieldWrapper;